import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../../theme/palette';

const style = () =>
  createStyles({
    root: {
      color: palette.text.primary,
      marginBottom: '10px'
    },
    line1: {
      display: 'flex',
      gap: '10px',
      alignItems: 'center',
      justifyContent: 'space-between'
    },
    nom: {
      fontSize: '1.25rem',
      fontWeight: 600,
      '@media (max-width:769px)': {
        fontSize: '1rem'
      }
    },
    infos: {
      fontSize: '16px',
      fontWeight: 500,
      margin: 0
    },
    line2: {
      display: 'flex',
      gap: '25px',
      alignItems: 'center'
    },
    line25: {
      display: 'flex',
      gap: '20px',
      alignItems: 'center',
      flexWrap: 'wrap',
      justifyContent: 'center',
      '@media (max-width:769px)': {
        justifyContent: 'flex-end',
        flexDirection: 'column'
      },
      '@media (max-width:1025px)': {
        gap: '10px'
      }
    },
    line3: {
      display: 'flex',
      justifyContent: 'flex-end'
    },
    image: {
      width: '50px',
      '@media (max-width:425px)': {
        display: 'none'
      }
    }
  });
const useStyle = makeStyles(style);
export default useStyle;
